export default {
  methods: {

    set_LocalValues(){

      // DataItems
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
  
      // Json
      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.title    = json.title
      this.table    = json.table
      this.columns  = json.columns

      this.scroll   = json.scroll
      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      this.gmx_tableCoordinates('x', this.columns, 10)
      this.table.width = this.columns[this.columns.length-1].ex

      this.current = {itr: 'A'}

      // Scroll Bar
      this.scroll.bar = {...json.scroll.bar,
        y: 0,
        size: null,
        ratio: null,
        space: null,
      }
      this.scroll.viewbox = {...json.scroll.viewbox,
        space: null,
      }
      this.scroll.content = {
        y: 0,
        height: null,
      }
    },


    set_ScrollValues() {
      // Scroll Pre-Proceassing
      this.scroll.bar.size = this.scroll.viewbox.height / this.scroll.content.height * this.scroll.viewbox.height
      this.scroll.viewbox.space = this.scroll.content.height - this.scroll.viewbox.height
      this.scroll.bar.space = this.scroll.viewbox.height - this.scroll.bar.size
    },

  }
}